module.exports = "/lucky-balls/img/bonus_green/check_infoBar/check_009.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/bonus_green/check_infoBar/check_009.png
// module id = 932
// module chunks = 0